(function (tinymce, window) {
    'use strict';

    tinymce.baseURL = window.location.origin + '/web3/build/base/js/tinymce-old/';

    function htmlEditorSettings_attachCallbacks (ed) {
        if (ed.settings['event_callback_focus_' + ed.id]) {
            tinymce.dom.Event.add(ed.getWin(), 'focus', function (e) {
                ed.settings['event_callback_focus_' + ed.id](ed, e);
            });
        }
        if (ed.settings['event_callback_blur_' + ed.id]) {
            tinymce.dom.Event.add(ed.getWin(), 'blur', function (e) {
                ed.settings['event_callback_blur_' + ed.id](ed, e);
            });
        }
    }

    window.htmlEditorSettings = {
        jobDescription: {
            // mode: 'none',
            theme: 'advanced',
            plugins: 'style,layer,table,paste,advimage,advlink,inlinepopups',
            theme_advanced_buttons1: 'bold,italic,underline,|,bullist,numlist,|,code',
            theme_advanced_buttons2: '',
            theme_advanced_buttons3: '',
            theme_advanced_toolbar_location: 'top',
            theme_advanced_toolbar_align: 'left',
            content_css: '/web3/build/base/css/html-editor.css',
            skin: 'tbg',
            relative_urls: false,
            convert_urls: true,
            apply_source_formatting: true,
            extended_valid_elements: 'iframe[id|class|title|style|align|frameborder|height|longdesc|marginheight|marginwidth|name|scrolling|src|width]',
            height: '160',
            width: '100%',
            theme_advanced_statusbar_location: '',
            theme_advanced_resizing: false,
            theme_advanced_resizing_use_cookie: false,
            theme_advanced_resize_horizontal: false,
            theme_advanced_source_editor_width: 750,
            theme_advanced_source_editor_height: 400,
            theme_advanced_source_editor_wrap: true,
            init_instance_callback: htmlEditorSettings_attachCallbacks
        }
    };
}(tinymce, window));
